// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3VoHU","title":"Images45_title__3gzMT","images":"Images45_images__Dr4PI"};